__turbopack_context__.v({
  "dnBody": "digest-next-module__pz1S8a__dnBody",
  "dnBrief": "digest-next-module__pz1S8a__dnBrief",
  "dnBriefBody": "digest-next-module__pz1S8a__dnBriefBody",
  "dnBriefSub": "digest-next-module__pz1S8a__dnBriefSub",
  "dnBriefTitle": "digest-next-module__pz1S8a__dnBriefTitle",
  "dnCarve": "digest-next-module__pz1S8a__dnCarve",
  "dnChip": "digest-next-module__pz1S8a__dnChip",
  "dnChipAvatar": "digest-next-module__pz1S8a__dnChipAvatar",
  "dnChipCount": "digest-next-module__pz1S8a__dnChipCount",
  "dnChipName": "digest-next-module__pz1S8a__dnChipName",
  "dnChips": "digest-next-module__pz1S8a__dnChips",
  "dnContent": "digest-next-module__pz1S8a__dnContent",
  "dnEditionLine": "digest-next-module__pz1S8a__dnEditionLine",
  "dnEditionLineInner": "digest-next-module__pz1S8a__dnEditionLineInner",
  "dnFailed": "digest-next-module__pz1S8a__dnFailed",
  "dnFailedIcon": "digest-next-module__pz1S8a__dnFailedIcon",
  "dnFailedPage": "digest-next-module__pz1S8a__dnFailedPage",
  "dnFailedText": "digest-next-module__pz1S8a__dnFailedText",
  "dnFailedTitle": "digest-next-module__pz1S8a__dnFailedTitle",
  "dnHero": "digest-next-module__pz1S8a__dnHero",
  "dnHeroCopy": "digest-next-module__pz1S8a__dnHeroCopy",
  "dnHeroPill": "digest-next-module__pz1S8a__dnHeroPill",
  "dnHeroStandfirst": "digest-next-module__pz1S8a__dnHeroStandfirst",
  "dnHeroTitle": "digest-next-module__pz1S8a__dnHeroTitle",
  "dnLoadingDot": "digest-next-module__pz1S8a__dnLoadingDot",
  "dnLoadingStatus": "digest-next-module__pz1S8a__dnLoadingStatus",
  "dnMiniWheel": "digest-next-module__pz1S8a__dnMiniWheel",
  "dnPanel": "digest-next-module__pz1S8a__dnPanel",
  "dnPanelBody": "digest-next-module__pz1S8a__dnPanelBody",
  "dnPanelMark": "digest-next-module__pz1S8a__dnPanelMark",
  "dnPanelText": "digest-next-module__pz1S8a__dnPanelText",
  "dnPanelTextNarrow": "digest-next-module__pz1S8a__dnPanelTextNarrow",
  "dnPanelTitle": "digest-next-module__pz1S8a__dnPanelTitle",
  "dnRetry": "digest-next-module__pz1S8a__dnRetry",
  "dnSampleChip": "digest-next-module__pz1S8a__dnSampleChip",
  "dnShaderFallback": "digest-next-module__pz1S8a__dnShaderFallback",
  "dnShaderHost": "digest-next-module__pz1S8a__dnShaderHost",
  "dnShaderLive": "digest-next-module__pz1S8a__dnShaderLive",
  "dnShaderReady": "digest-next-module__pz1S8a__dnShaderReady",
  "dnSheet": "digest-next-module__pz1S8a__dnSheet",
  "dnSource": "digest-next-module__pz1S8a__dnSource",
  "dnStack": "digest-next-module__pz1S8a__dnStack",
  "dnStackAvatar": "digest-next-module__pz1S8a__dnStackAvatar",
  "dnStackGhost": "digest-next-module__pz1S8a__dnStackGhost",
  "dnStackMore": "digest-next-module__pz1S8a__dnStackMore",
  "dnTab": "digest-next-module__pz1S8a__dnTab",
  "dnTabGhostSlot": "digest-next-module__pz1S8a__dnTabGhostSlot",
  "dnTabLabel": "digest-next-module__pz1S8a__dnTabLabel",
  "dnTabList": "digest-next-module__pz1S8a__dnTabList",
  "dnTabPanel": "digest-next-module__pz1S8a__dnTabPanel",
  "dnTabRow": "digest-next-module__pz1S8a__dnTabRow",
  "dnTabStatic": "digest-next-module__pz1S8a__dnTabStatic",
  "dnTabStaticActive": "digest-next-module__pz1S8a__dnTabStaticActive",
  "dnTabs": "digest-next-module__pz1S8a__dnTabs",
  "dnTodo": "digest-next-module__pz1S8a__dnTodo",
  "dnTodoCard": "digest-next-module__pz1S8a__dnTodoCard",
  "dnTodoCards": "digest-next-module__pz1S8a__dnTodoCards",
  "dnTodoCheck": "digest-next-module__pz1S8a__dnTodoCheck",
  "dnTodoClosingLine": "digest-next-module__pz1S8a__dnTodoClosingLine",
  "dnTodoColumn": "digest-next-module__pz1S8a__dnTodoColumn",
  "dnTodoColumnEmpty": "digest-next-module__pz1S8a__dnTodoColumnEmpty",
  "dnTodoColumnHead": "digest-next-module__pz1S8a__dnTodoColumnHead",
  "dnTodoColumns": "digest-next-module__pz1S8a__dnTodoColumns",
  "dnTodoCount": "digest-next-module__pz1S8a__dnTodoCount",
  "dnTodoCounter": "digest-next-module__pz1S8a__dnTodoCounter",
  "dnTodoDate": "digest-next-module__pz1S8a__dnTodoDate",
  "dnTodoDone": "digest-next-module__pz1S8a__dnTodoDone",
  "dnTodoDoneHead": "digest-next-module__pz1S8a__dnTodoDoneHead",
  "dnTodoDoneRuled": "digest-next-module__pz1S8a__dnTodoDoneRuled",
  "dnTodoDot": "digest-next-module__pz1S8a__dnTodoDot",
  "dnTodoEmptyLine": "digest-next-module__pz1S8a__dnTodoEmptyLine",
  "dnTodoFoot": "digest-next-module__pz1S8a__dnTodoFoot",
  "dnTodoFootName": "digest-next-module__pz1S8a__dnTodoFootName",
  "dnTodoGhostCard": "digest-next-module__pz1S8a__dnTodoGhostCard",
  "dnTodoHead": "digest-next-module__pz1S8a__dnTodoHead",
  "dnTodoHeadText": "digest-next-module__pz1S8a__dnTodoHeadText",
  "dnTodoMeta": "digest-next-module__pz1S8a__dnTodoMeta",
  "dnTodoRow": "digest-next-module__pz1S8a__dnTodoRow",
  "dnTodoSphere": "digest-next-module__pz1S8a__dnTodoSphere",
  "dnTodoStatus": "digest-next-module__pz1S8a__dnTodoStatus",
  "dnTodoSub": "digest-next-module__pz1S8a__dnTodoSub",
  "dnTodoTitle": "digest-next-module__pz1S8a__dnTodoTitle",
  "dnTodoTitleLink": "digest-next-module__pz1S8a__dnTodoTitleLink",
  "dnWheelCard": "digest-next-module__pz1S8a__dnWheelCard",
  "dnWheelCardFloating": "digest-next-module__pz1S8a__dnWheelCardFloating",
  "dnWheelChip": "digest-next-module__pz1S8a__dnWheelChip",
  "dnWheelChipLine": "digest-next-module__pz1S8a__dnWheelChipLine",
  "dnWheelChipName": "digest-next-module__pz1S8a__dnWheelChipName",
  "dnWheelChipRow": "digest-next-module__pz1S8a__dnWheelChipRow",
  "dnWheelChipTab": "digest-next-module__pz1S8a__dnWheelChipTab",
  "dnWheelChipTabActive": "digest-next-module__pz1S8a__dnWheelChipTabActive",
  "dnWheelChipTrack": "digest-next-module__pz1S8a__dnWheelChipTrack",
  "dnWheelDate": "digest-next-module__pz1S8a__dnWheelDate",
  "dnWheelDateRow": "digest-next-module__pz1S8a__dnWheelDateRow",
  "dnWheelDateTile": "digest-next-module__pz1S8a__dnWheelDateTile",
  "dnWheelDetail": "digest-next-module__pz1S8a__dnWheelDetail",
  "dnWheelDetailInner": "digest-next-module__pz1S8a__dnWheelDetailInner",
  "dnWheelFade": "digest-next-module__pz1S8a__dnWheelFade",
  "dnWheelFadeBottom": "digest-next-module__pz1S8a__dnWheelFadeBottom",
  "dnWheelFadeTop": "digest-next-module__pz1S8a__dnWheelFadeTop",
  "dnWheelGhostColumn": "digest-next-module__pz1S8a__dnWheelGhostColumn",
  "dnWheelGhostHeader": "digest-next-module__pz1S8a__dnWheelGhostHeader",
  "dnWheelGhostHost": "digest-next-module__pz1S8a__dnWheelGhostHost",
  "dnWheelGhostLines": "digest-next-module__pz1S8a__dnWheelGhostLines",
  "dnWheelGhostMobile": "digest-next-module__pz1S8a__dnWheelGhostMobile",
  "dnWheelGhostPill": "digest-next-module__pz1S8a__dnWheelGhostPill",
  "dnWheelGhostStack": "digest-next-module__pz1S8a__dnWheelGhostStack",
  "dnWheelGhostTablet": "digest-next-module__pz1S8a__dnWheelGhostTablet",
  "dnWheelGradient": "digest-next-module__pz1S8a__dnWheelGradient",
  "dnWheelGradientCompany": "digest-next-module__pz1S8a__dnWheelGradientCompany",
  "dnWheelGradientIndication": "digest-next-module__pz1S8a__dnWheelGradientIndication",
  "dnWheelGradientLayer": "digest-next-module__pz1S8a__dnWheelGradientLayer",
  "dnWheelGradientReadout": "digest-next-module__pz1S8a__dnWheelGradientReadout",
  "dnWheelGradientResearch": "digest-next-module__pz1S8a__dnWheelGradientResearch",
  "dnWheelGradientTrial": "digest-next-module__pz1S8a__dnWheelGradientTrial",
  "dnWheelHeader": "digest-next-module__pz1S8a__dnWheelHeader",
  "dnWheelHeaderText": "digest-next-module__pz1S8a__dnWheelHeaderText",
  "dnWheelHeadline": "digest-next-module__pz1S8a__dnWheelHeadline",
  "dnWheelHeadlineLong": "digest-next-module__pz1S8a__dnWheelHeadlineLong",
  "dnWheelHeadlineShort": "digest-next-module__pz1S8a__dnWheelHeadlineShort",
  "dnWheelIcon": "digest-next-module__pz1S8a__dnWheelIcon",
  "dnWheelLink": "digest-next-module__pz1S8a__dnWheelLink",
  "dnWheelLinkRow": "digest-next-module__pz1S8a__dnWheelLinkRow",
  "dnWheelMiddle": "digest-next-module__pz1S8a__dnWheelMiddle",
  "dnWheelMiddleWrap": "digest-next-module__pz1S8a__dnWheelMiddleWrap",
  "dnWheelName": "digest-next-module__pz1S8a__dnWheelName",
  "dnWheelNarrowBlock": "digest-next-module__pz1S8a__dnWheelNarrowBlock",
  "dnWheelNarrowBody": "digest-next-module__pz1S8a__dnWheelNarrowBody",
  "dnWheelNarrowDetail": "digest-next-module__pz1S8a__dnWheelNarrowDetail",
  "dnWheelNarrowFoot": "digest-next-module__pz1S8a__dnWheelNarrowFoot",
  "dnWheelNarrowGhost": "digest-next-module__pz1S8a__dnWheelNarrowGhost",
  "dnWheelNarrowGhostDetail": "digest-next-module__pz1S8a__dnWheelNarrowGhostDetail",
  "dnWheelNarrowGhostHost": "digest-next-module__pz1S8a__dnWheelNarrowGhostHost",
  "dnWheelNarrowGhostPanel": "digest-next-module__pz1S8a__dnWheelNarrowGhostPanel",
  "dnWheelNarrowHeadline": "digest-next-module__pz1S8a__dnWheelNarrowHeadline",
  "dnWheelNarrowInner": "digest-next-module__pz1S8a__dnWheelNarrowInner",
  "dnWheelNarrowPanel": "digest-next-module__pz1S8a__dnWheelNarrowPanel",
  "dnWheelNarrowSourceRow": "digest-next-module__pz1S8a__dnWheelNarrowSourceRow",
  "dnWheelNoSource": "digest-next-module__pz1S8a__dnWheelNoSource",
  "dnWheelPill": "digest-next-module__pz1S8a__dnWheelPill",
  "dnWheelPillActive": "digest-next-module__pz1S8a__dnWheelPillActive",
  "dnWheelPillLine": "digest-next-module__pz1S8a__dnWheelPillLine",
  "dnWheelPillName": "digest-next-module__pz1S8a__dnWheelPillName",
  "dnWheelPillText": "digest-next-module__pz1S8a__dnWheelPillText",
  "dnWheelRow": "digest-next-module__pz1S8a__dnWheelRow",
  "dnWheelRowLabel": "digest-next-module__pz1S8a__dnWheelRowLabel",
  "dnWheelRowValue": "digest-next-module__pz1S8a__dnWheelRowValue",
  "dnWheelRowValueLink": "digest-next-module__pz1S8a__dnWheelRowValueLink",
  "dnWheelRows": "digest-next-module__pz1S8a__dnWheelRows",
  "dnWheelShaderCopy": "digest-next-module__pz1S8a__dnWheelShaderCopy",
  "dnWheelShaderHost": "digest-next-module__pz1S8a__dnWheelShaderHost",
  "dnWheelShaderOverlays": "digest-next-module__pz1S8a__dnWheelShaderOverlays",
  "dnWheelShaderReady": "digest-next-module__pz1S8a__dnWheelShaderReady",
  "dnWheelSource": "digest-next-module__pz1S8a__dnWheelSource",
  "dnWheelSphere": "digest-next-module__pz1S8a__dnWheelSphere",
  "dnWheelSpokes": "digest-next-module__pz1S8a__dnWheelSpokes",
  "dnWheelStage": "digest-next-module__pz1S8a__dnWheelStage",
  "dnWheelStep": "digest-next-module__pz1S8a__dnWheelStep",
  "dnWheelStepCount": "digest-next-module__pz1S8a__dnWheelStepCount",
  "dnWheelStepper": "digest-next-module__pz1S8a__dnWheelStepper",
  "dnWheelSub": "digest-next-module__pz1S8a__dnWheelSub",
  "dnWheelTabs": "digest-next-module__pz1S8a__dnWheelTabs",
  "dnWheelText": "digest-next-module__pz1S8a__dnWheelText",
  "dnWheelTextPara": "digest-next-module__pz1S8a__dnWheelTextPara",
  "dnWheelTile": "digest-next-module__pz1S8a__dnWheelTile",
  "dnWheelTypeLine": "digest-next-module__pz1S8a__dnWheelTypeLine",
  "dnWheelWrap": "digest-next-module__pz1S8a__dnWheelWrap",
});
